export default __webpack_public_path__ + "static/media/k_wdt_c_3_4.976226c8.mp3";